import { render } from "./documentList.vue?vue&type=template&id=480eb6e1&scoped=true"
import script from "./documentList.js?vue&type=script&lang=js"
export * from "./documentList.js?vue&type=script&lang=js"

import "./documentList.vue?vue&type=style&index=0&id=480eb6e1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480eb6e1"]])

export default __exports__